import {ChartEventTypeDomainModel} from "./chart-event-type.domain-model";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import {GAME_SHOT_CHARTS} from "../../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";

export class ChartEventTypeViewModel extends BaseViewModel {
  value: Number;

  constructor(model: ChartEventTypeDomainModel){
    super(model);

    this.value = model.value;
  }

  get isMadeShot() {
    return this.value === GAME_SHOT_CHARTS.SHOT_TYPE.made;
  }

  get isMissedShot() {
    return this.value === GAME_SHOT_CHARTS.SHOT_TYPE.miss;
  }
}
